export default __webpack_public_path__ + "static/media/options-toggle-btn.ba3f8091.svg";